import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const DatePickerInputWrapper = styled.div`
  label {
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      margin-bottom: 4px !important;
      padding-inline-start: 12px;
      color: ${theme.colours.blackText};
      display: inline-block;
      span {
        color: ${theme.colours.error} !important;
        font-size: 15px;
      }
    }
  }

  input {
    width: 100%;
    font-family: ${theme.fonts.Medium};
    font-size: 14px;
    height: 32px !important;
    min-height: 32px !important;
    color: ${theme.colours.blackText};
    background-color: ${theme.colours.white};
    padding: 12px 20px;
    border-radius: 6px;
    border: 1px solid ${theme.colours.SpanishGray};
    text-align: inherit;
    &::placeholder {
      color: ${theme.colours.Nickel};
    }
    &:lang(ar) {
      text-align: right;
    }
    &:focus {
      font-size: 14px;
    }
  }

  & > p {
    color: ${theme.colours.blackText};
    margin-top: 8px;
  }
  .mantine-DatePicker-calendarHeader {
    direction: ltr;
  }
  .mantine-DatePicker-month {
    direction: ltr;
  }
  .hasError .mantine-Input-input.mantine-DateInput-input {
    border-color: ${theme.colours.error} !important;
  }
  button[data-weekend],
  .mantine-DatePicker-day {
    color: ${theme.colours.blackText} !important;
  }
  
  .mantine-DateInput-day[data-weekend] {
    color: ${theme.colours.blackText} !important;
  }
  
  .mantine-DateInput-day[data-weekend][data-selected] {
    color: white !important;
  }
  
  button[data-weekend][data-selected],
  .mantine-DatePicker-day[data-weekend][data-selected] {
    color: white !important;
  }
`;
